<template>
    <div class="full-width-flex info-text">
        <div>
            <span class="file-type">
                <font-awesome-icon icon="fa-regular fa-file" v-if="fileType == 'other'" />
                <font-awesome-icon icon="fa-regular fa-file-video" v-if="fileType == 'video'" />
                <font-awesome-icon icon="fa-regular fa-file-image" v-if="fileType == 'image'" />
                <font-awesome-icon icon="fa-regular fa-file-audio" v-if="fileType == 'audio'" />
            </span>
            <span class="file-name-text">{{decodeURI(obj.filename)}}</span>
        </div>

        <div>
            <span class="file-size">{{fileSize}}</span>
            <span class="download-btn"><font-awesome-icon icon="fa-solid fa-cloud-arrow-down" @click="goDownloadFile" /></span>
        </div>
    </div>
</template>

<script setup>
    import {inject, onMounted, onBeforeMount, ref, computed, getCurrentInstance} from "vue";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons'
    import { faFile, faFileVideo, faFileImage, faFileAudio } from '@fortawesome/free-regular-svg-icons'
    import myUtil from "@/util/util";

    library.add(faCloudArrowDown, faFile, faFileVideo, faFileImage, faFileAudio)

    const props = defineProps(["obj", "roomId"])

    const { proxy } = getCurrentInstance()

    const fileSize = computed(() => {
        let sizeText = "0 B"

        if (null != props.obj && null != props.obj.size){
            sizeText = myUtil.calcFileSize(props.obj.size)
        }

        return sizeText
    })

    const fileType = computed(() => {
        let type = "other"
        let fileType = props.obj.type

        if (null != fileType){
            const index = fileType.indexOf("/")
            if (index == -1){
                type = "other"
            }else{
                type = fileType.substring(0, index)
            }
        }

        return type
    })

    function goDownloadFile() {
        if (null == props.roomId){
            return
        }

        let url = `${proxy.$ShopopeeHttp}chat/downloadChatFile?roomId=${props.roomId}&sysFilename=${props.obj.sysFilename}&filename=${props.obj.filename}`
        url = encodeURI(url)

        window.open(url)
    }

</script>

<style scoped>
    .full-width-flex {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        box-sizing: border-box;
    }

    .info-text {
        color: #606266;
        font-size: 16px;
        border-bottom: 1px #EBEEF5 solid;
        line-height: 1.5;
    }

    .file-type {
        font-size: 20px;
    }

    .file-name-text {
        font-size: 14px;
        margin-left: 10px;
    }

    .file-size {
        font-size: 14px;
    }

    .download-btn {
        margin-left: 10px;
        font-size: 20px;
        color: #409EFF;
        cursor: pointer;
    }
</style>